import { GameStatus } from "sbtech-sports-data-api-contracts";
export const mapKickOffState = (x) => {
    x.isInKickOffState = x.isLive && x.status === GameStatus.NotStarted;
    return x;
};
//# sourceMappingURL=mapKickOffState.js.map